import Vue from 'vue';
import { AclInstaller, AclCreate, AclRule } from 'vue-acl';
import router from '../router';
import store from '../store';

Vue.use(AclInstaller);

export default new AclCreate({
  initial: 'public',
  notfound: {
    path: '/not-found',
    forwardQueryParams: true
  },
  router,
  acceptLocalRules: true,
  globalRules: {
    isPublic: new AclRule('public').generate(),
    isGeneral: new AclRule('cerdas_admin')
      .or('school_admin')
      .or('school_advisor')
      .or('teacher')
      .or('parent')
      .or('student')
      .generate(),
    isAll: new AclRule('public')
      .or('cerdas_admin')
      .or('school_admin')
      .or('school_advisor')
      .or('teacher')
      .or('parent')
      .or('student')
      .generate(),
    isCerdasAdmin: new AclRule('cerdas_admin').generate(),
    isSchoolAdmin: new AclRule('school_admin').generate(),
    isSchoolAdminTeacherAdvisor: new AclRule('school_admin')
      .or('teacher')
      .or('school_advisor')
      .generate(),
    isSchoolAdminTeacher: new AclRule('school_admin').or('teacher').generate(),
    isSchoolAdminAdvisor: new AclRule('school_admin').or('school_advisor').generate(),
    isTeacher: new AclRule('teacher').generate(),
    isParent: new AclRule('parent').generate(),
    isStudent: new AclRule('student').generate(),
    isSchoolAdvisor: new AclRule('school_advisor').generate(),
    isStudentParent: new AclRule('student').or('parent').generate(),
    isStudentTeacher: new AclRule('student').or('teacher').generate()
  },
  middleware: async acl => {
    const currentRole = store.getters['Auth/currentRole'];
    switch (currentRole) {
      case 1:
        acl.change('cerdas_admin');
        break;
      case 2:
        acl.change('school_admin');
        break;
      case 3:
        acl.change('parent');
        break;
      case 4:
        acl.change('teacher');
        break;
      case 5:
        acl.change('student');
        break;
      case 6:
        acl.change('school_advisor');
        break;
      default:
        acl.change('public');
    }
  }
});
